import React, { Component } from "react";
import { ToastContainer } from "react-toastify";
import toast from "../helpers/toast";
import Httpconfig from "../helpers/HttpconfigAdmin";
import Constant from "../../constants";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Header from "./Header";
import Sidebar from "./sidebar";
const moment = require("moment");

export default class CreateAdminBanners extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {},
      errors: {},
      banner_images: [],
      bannerImagePreviews: [],
      isUpdate: false,
    };
  }

  componentDidMount() {
    const { match } = this.props;
    if (match && match.params && match.params.handle) {
      this.setState({ isUpdate: true }, () => {
        this.getBannerInfo(match.params.handle);
        console.log("banner id vro: ", match.params.banner_id);
      });
    }
  }

  getBannerInfo = (banner_id) => {
    console.log("Fetching banner info for id:", banner_id);
    // console.log("Fetching banner info for id:", banner_id);
    const payload = {
      module_type: "",
      status: "",
      search: "",
      page: 1,
      limit: 1,
      banner_id: banner_id,
    };
    Httpconfig.httptokenpost(Constant.siteurl + "api/OM/Banners/list", payload)
      .then((response) => {
        const data = response.data.data && response.data.data[0];
        if (data) {
          this.setState({
            fields: {
              banner_id: data.banner_id,
              banner_name: data.banner_name,
              description: data.description || "",
              category: data.position,
              redirection_tags: data.redirection_tags,
              status: data.status === "active" ? "ACTIVE" : "INACTIVE",
            },
            start_date: new Date(data.start_date),
            end_date: new Date(data.end_date),
            banner_images: data.images.map((img, idx) => ({
              file: null,
              base64: img.image_url,
              name: img.alt_text || `Banner ${idx + 1}`,
            })),
            bannerImagePreviews: data.images.map((img) => img.image_url),
          });
        }
      })
      .catch((error) => {
        toast.error("Failed to fetch banner info");
      });
  };

  setStartTimeOnChange = (value) => {
    this.setState({ start_date: value });
  };
  setEndTimeOnChange = (value) => {
    this.setState({ end_date: value });
  };

  // Helper to convert File to base64
  convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };

  handleBannerImagesChange = async (event) => {
    const newFiles = Array.from(event.target.files);
    const banner_images = [];
    for (let file of newFiles) {
      const base64 = await this.convertFileToBase64(file);
      banner_images.push({ file, base64, name: file.name });
    }
    this.setState({
      banner_images: [...this.state.banner_images, ...banner_images],
      bannerImagePreviews: [
        ...this.state.bannerImagePreviews,
        ...banner_images.map((img) => img.base64),
      ],
    });
  };

  removeBannerImage = (idx) => {
    const banner_images = [...this.state.banner_images];
    const bannerImagePreviews = [...this.state.bannerImagePreviews];
    banner_images.splice(idx, 1);
    bannerImagePreviews.splice(idx, 1);
    this.setState({ banner_images, bannerImagePreviews });
  };

 checkSubmit(event) {
  event.preventDefault();
  if (this.handleValidation()) {
    if (this.state.isUpdate) {
      this.updateBanner(event);
    } else {
      this.createBanner(event);
    }
  } else {
    toast.warn("Form has errors.");
  }
}


  // creates new controller
  // createBanner = async (event) => {
  //   event.preventDefault();
  //   const { fields, banner_images } = this.state;
  //   const images = banner_images.map((img, idx) => ({
  //     image_url: img.base64,
  //     alt_text: img.name,
  //     sort_order: idx + 1,
  //   }));
  //   const payload = {
  //     module_id: 2,
  //     module_type: "pharmacy",
  //     banner_name: fields["banner_name"],
  //     description: fields["description"] || "",
  //     position: fields["category"] || "",
  //     start_date: moment(this.state.start_date).format("YYYY-MM-DD"),
  //     end_date: moment(this.state.end_date).format("YYYY-MM-DD"),
  //     redirection_tags: fields["redirection_tags"] || "",
  //     approval_status: "pending",
  //     status: fields["status"] === "ACTIVE" ? "active" : "inactive",
  //     created_by: 1,
  //     images,
  //     entity_id: 0,
  //   };
  //   // Use POST for create, PUT for update
  //   if (this.state.isUpdate && fields["banner_id"]) {
  //     // Update banner
  //     Httpconfig.httptokenput(
  //       Constant.siteurl + `api/OM/Banners/${fields["banner_id"]}`,
  //       payload
  //     )
  //       .then((response) => {
  //         toast.success("Banner Updated Successfully");
  //         setTimeout(() => this.props.history.push("/admin/Viewbanners"), 1000);
  //       })
  //       .catch((error) => {
  //         toast.error("Banner update failed");
  //       });
  //   } else {
  //     // Create banner
  //     Httpconfig.httptokenpost(Constant.siteurl + "api/OM/Banners/", payload)
  //       .then((response) => {
  //         toast.success("Banner Created Successfully");
  //         setTimeout(() => this.props.history.push("/admin/Viewbanners"), 1000);
  //       })
  //       .catch((error) => {
  //         toast.error("Banner creation failed");
  //       });
  //   }
  // };
createBanner = async (event) => {
  event.preventDefault();
  const { fields, banner_images } = this.state;
  const images = banner_images.map((img, idx) => ({
    image_url: img.base64,
    alt_text: img.name,
    sort_order: idx + 1,
  }));

  const payload = {
    module_id: 2,
    module_type: "pharmacy",
    banner_name: fields["banner_name"],
    description: fields["description"] || "",
    position: fields["category"] || "",
    start_date: moment(this.state.start_date).format("YYYY-MM-DD"),
    end_date: moment(this.state.end_date).format("YYYY-MM-DD"),
    redirection_tags: fields["redirection_tags"] || "",
    approval_status: "pending",
    status: fields["status"] === "ACTIVE" ? "active" : "inactive",
    created_by: 1,
    images,
    entity_id: 0,
  };

  Httpconfig.httptokenpost(Constant.siteurl + "api/OM/Banners/", payload)
    .then((response) => {
      toast.success("Banner Created Successfully");
      setTimeout(() => this.props.history.push("/admin/Viewbanners"), 1000);
    })
    .catch((error) => {
      toast.error("Banner creation failed");
    });
};

updateBanner = async (event) => {
  event.preventDefault();
  const { fields, banner_images } = this.state;
  const images = banner_images.map((img, idx) => ({
    image_url: img.base64,
    alt_text: img.name,
    sort_order: idx + 1,
  }));

  const payload = {
    module_id: 2,
    module_type: "pharmacy",
    banner_name: fields["banner_name"],
    description: fields["description"] || "",
    position: fields["category"] || "",
    start_date: moment(this.state.start_date).format("YYYY-MM-DD"),
    end_date: moment(this.state.end_date).format("YYYY-MM-DD"),
    redirection_tags: fields["redirection_tags"] || "",
    approval_status: "pending",
    status: fields["status"] === "ACTIVE" ? "active" : "inactive",
    updated_by: 1,
    images,
    entity_id: 0,
  };

  Httpconfig.httptokenput(
    Constant.siteurl + `api/OM/Banners/${fields["banner_id"]}`,
    payload
  )
    .then((response) => {
      toast.success("Banner Updated Successfully");
      setTimeout(() => this.props.history.push("/admin/Viewbanners"), 1000);
    })
    .catch((error) => {
      toast.error("Banner update failed");
    });
};

  handleValidation() {
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;
    if (!fields["banner_name"]) {
      formIsValid = false;
      errors["banner_name"] = "Banner name cannot be empty";
    } else if (!/^[@ _ a-zA-Z0-9- ]*$/.exec(fields["banner_name"])) {
      formIsValid = false;
      errors["banner_name"] = "Banner name contains invalid characters";
    }
    if (!fields["category"]) {
      formIsValid = false;
      errors["category"] = "Category cannot be empty";
    }
    if (!this.state.start_date) {
      formIsValid = false;
      errors["start_date"] = "Start Date cannot be empty";
    }
    if (!this.state.end_date) {
      formIsValid = false;
      errors["end_date"] = "End Date cannot be empty";
    }
    if (!fields["redirection_tags"]) {
      formIsValid = false;
      errors["redirection_tags"] = "Redirection tags cannot be empty";
    }
    if (!fields["status"]) {
      formIsValid = false;
      errors["status"] = "Status cannot be empty";
    }
    if (this.state.banner_images.length === 0) {
      formIsValid = false;
      errors["banner_images"] = "Please upload at least one banner image";
    }
    this.setState({ errors: errors });
    return formIsValid;
  }

  handleChange = (field, event) => {
    let fields = this.state.fields;
    fields[field] = event.target.value;
    this.setState({ fields });
  };

  render() {
    const { fields, errors, isUpdate } = this.state;
    return (
      <main id="main">
        <Header />
        <Sidebar />
        <section
          id="main_dashboard"
          className="col-md-offset-2"
          style={{ marginLeft: "180px" }}
        >
          <div className="container-fluid" id="main_front">
            <div className="row">
              <div className="col-md-10">
                <div className="dash-section">
                  <div className="section-header">
                    <ol className="breadcrumb">
                      <li className="active">
                        <Link to="/admin"> Dashboard</Link> &gt;
                        <a> Banners </a>
                      </li>
                    </ol>
                  </div>
                </div>
                <section id="CMS_tab">
                  <div className="CMS_content create_calender">
                    <div className="container">
                      <div className="row">
                        <div className="tab-header">
                          <h3>
                            {isUpdate
                              ? "Update Banner Management"
                              : "Create Banner Management"}
                          </h3>
                        </div>
                        <div id="reg_form">
                          <form onSubmit={this.checkSubmit.bind(this)}>
                            <div className="row">
                              <div className="col-md-4">
                                <div className="form-group ">
                                  <label
                                    htmlFor="customRadio2"
                                    className="custom-control-label"
                                  >
                                    Banner Name
                                  </label>
                                  <input
                                    type="text"
                                    name="banner_name"
                                    value={fields["banner_name"] || ""}
                                    onChange={this.handleChange.bind(
                                      this,
                                      "banner_name"
                                    )}
                                    className="form-control"
                                    placeholder="Banner Name"
                                  />
                                  <span className="cRed">
                                    {errors["banner_name"]}
                                  </span>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label
                                    htmlFor="category"
                                    className="custom-control-label"
                                  >
                                    Category
                                  </label>
                                  <select
                                    id="category"
                                    name="category"
                                    className="form-control"
                                    value={fields["category"] || ""}
                                    onChange={this.handleChange.bind(
                                      this,
                                      "category"
                                    )}
                                  >
                                    <option value="" disabled>
                                      Select Category
                                    </option>
                                    <option value="Header">HEADER</option>
                                    <option value="Footer">FOOTER</option>
                                    <option value="Middle">MIDDLE</option>
                                    <option value="Personal Care">
                                      PERSONAL CARE
                                    </option>
                                    <option value="Latest Offers">
                                      LATEST OFFERS
                                    </option>
                                    <option value="homepage">
                                      HOMEPAGE
                                    </option>
                                  </select>
                                  <span className="cRed">
                                    {errors["category"]}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-4">
                                <div className="form-group ">
                                  <label
                                    htmlFor="customRadio2"
                                    className="custom-control-label"
                                  >
                                    Start Date
                                  </label>
                                  <DatePicker
                                    name="start_date"
                                    autoComplete="off"
                                    className="dateInput"
                                    placeholderText="Start Date"
                                    popperPlacement="bottom"
                                    minDate={new Date()}
                                    popperModifiers={{
                                      flip: {
                                        behavior: ["bottom"],
                                      },
                                    }}
                                    selected={this.state.start_date}
                                    onChange={this.setStartTimeOnChange}
                                    dateFormat="yyyy-MM-d"
                                    calendarIcon
                                    showMonthDropdown
                                    adjustDateOnChange
                                  />
                                  <span className="cRed">
                                    {errors["start_date"]}
                                  </span>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="form-group ">
                                  <label
                                    htmlFor="customRadio2"
                                    className="custom-control-label"
                                  >
                                    End Date
                                  </label>
                                  <DatePicker
                                    name="end_date"
                                    autoComplete="off"
                                    className="dateInput"
                                    placeholderText="End Date"
                                    popperPlacement="bottom"
                                    minDate={new Date()}
                                    popperModifiers={{
                                      flip: {
                                        behavior: ["bottom"],
                                      },
                                    }}
                                    selected={this.state.end_date}
                                    onChange={this.setEndTimeOnChange}
                                    dateFormat="yyyy-MM-d"
                                    calendarIcon
                                    showMonthDropdown
                                    adjustDateOnChange
                                  />
                                  <span className="cRed">
                                    {errors["end_date"]}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label
                                    htmlFor="redirection_tags"
                                    className="custom-control-label"
                                  >
                                    Redirection Tags
                                  </label>
                                  <input
                                    type="text"
                                    name="redirection_tags"
                                    value={fields["redirection_tags"] || ""}
                                    onChange={this.handleChange.bind(
                                      this,
                                      "redirection_tags"
                                    )}
                                    className="form-control"
                                    placeholder="Enter tags like category, products"
                                  />
                                  <span className="cRed">
                                    {errors["redirection_tags"]}
                                  </span>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label
                                    htmlFor="banner_images"
                                    className="custom-control-label"
                                  >
                                    Upload Banner Image
                                  </label>
                                  <input
                                    type="file"
                                    name="banner_images"
                                    className="form-control"
                                    multiple
                                    accept="image/*"
                                    onChange={(e) =>
                                      this.handleBannerImagesChange(e)
                                    }
                                  />
                                  <span className="cRed">
                                    {errors["banner_images"]}
                                  </span>
                                </div>
                              </div>
                            </div>
                            {this.state.bannerImagePreviews &&
                              this.state.bannerImagePreviews.length > 0 && (
                                <div
                                  className="image-preview-list"
                                  style={{ marginTop: "10px" }}
                                >
                                  <label style={{ fontWeight: "bold" }}>
                                    Image Preview:
                                  </label>
                                  <div
                                    style={{
                                      display: "flex",
                                      gap: "10px",
                                      flexWrap: "wrap",
                                    }}
                                  >
                                    {this.state.bannerImagePreviews.map(
                                      (src, idx) => (
                                        <div
                                          key={idx}
                                          style={{
                                            textAlign: "center",
                                            position: "relative",
                                          }}
                                        >
                                          <img
                                            src={src}
                                            alt={`preview-${idx}`}
                                            style={{
                                              width: 80,
                                              height: 80,
                                              objectFit: "cover",
                                              border: "1px solid #ccc",
                                              borderRadius: 4,
                                            }}
                                          />
                                          <div
                                            style={{
                                              fontSize: 12,
                                              marginTop: 2,
                                            }}
                                          >
                                            {
                                              this.state.banner_images[idx]
                                                ?.name
                                            }
                                          </div>
                                          <button
                                            type="button"
                                            onClick={() =>
                                              this.removeBannerImage(idx)
                                            }
                                            style={{
                                              position: "absolute",
                                              top: 0,
                                              right: 0,
                                              background:
                                                "rgba(255,255,255,0.8)",
                                              border: "none",
                                              borderRadius: "50%",
                                              width: 22,
                                              height: 22,
                                              cursor: "pointer",
                                              color: "#d00",
                                              fontWeight: "bold",
                                              lineHeight: "18px",
                                              padding: 0,
                                            }}
                                            title="Remove"
                                          >
                                            ×
                                          </button>
                                        </div>
                                      )
                                    )}
                                  </div>
                                </div>
                              )}
                            <div className="row">
                              <div className="col-md-4">
                                <div className="form-group ">
                                  <label className="custom-control-label">
                                    Status
                                  </label>
                                  <div
                                    className="custom-control custom-radio"
                                    onChange={this.handleChange.bind(
                                      this,
                                      "status"
                                    )}
                                  >
                                    <input
                                      type="radio"
                                      value="ACTIVE"
                                      checked={fields["status"] === "ACTIVE"}
                                      name="status"
                                    />{" "}
                                    Active &nbsp;&nbsp;&nbsp;
                                    <input
                                      type="radio"
                                      value="INACTIVE"
                                      checked={fields["status"] === "INACTIVE"}
                                      name="status"
                                    />{" "}
                                    Inactive
                                  </div>
                                  <span className="cRed">
                                    {errors["status"]}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="form-group col-md-12">
                                <button
                                  type="submit"
                                  className="btn  btn-primary save_btn"
                                >
                                  Save Banner
                                </button>{" "}
                                &nbsp;
                                <Link
                                  to="/admin/Viewbanners"
                                  className="cancel_btn"
                                >
                                  Cancel
                                </Link>{" "}
                                &nbsp; &nbsp;
                              </div>
                            </div>
                          </form>
                        </div>
                        <ToastContainer />
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
      </main>
    );
  }
}
